module.exports = __webpack_public_path__ + "img/diamond.ef004b56.png";